module.exports = __webpack_public_path__ + "img/dashboard-report-icon.ffde448f.svg";